module.exports = __webpack_public_path__ + "img/client.33f99b8d.svg";